import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    '& *:focus': {
      outline: 'none',
    },
  },
}));

export const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 20;
  color: white;
  font-size: 1.2em;
  white-space: pre-line;
  text-align: center;
`;

export const Message = styled.p`
  color: whitesmoke;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  box-sizing: border-box;
  font-size: 1.2em;
  
`;

export const Error = ({ message, showBackButton, history }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorContainer>
      <Message>{message}</Message>
      {showBackButton && (
        <Button className={classes.root} variant="outlined" size="large" onClick={() => history.push('/')}>
          {t('go.back')}
        </Button>
      )}
    </ErrorContainer>
  );
};

export default Error;
